import { Input, Select } from 'antd'
import { Book, useBooks } from 'pages/KnowledgeBasePage/BooksList'
import React, { ReactNode, useCallback, useEffect, useState } from 'react'
import Spinner from './Spinner'
import Button from './Button'
import { ReactComponent as ExternalLink } from 'resources/images/external_link.svg'

type Props = {}

export default function useBookRangeSelector(): [string | undefined, () => ReactNode] {
    const { isLoading: isFetchingBooks, data: books = [] } = useBooks("org")
    const [book, setBook] = useState<Book>()
    const [startPage, setStartPage] = useState<number>()
    const [endPage, setEndPage] = useState<number>()
    const [bookURL, setBookURL] = useState<string>()

    useEffect(() => {
        if (book) {
            let url = new URL(book.file.url)
            const setParam = (attr, value) => {
                if (value) {
                    url.searchParams.set(attr, value)
                } else {
                    url.searchParams.delete(attr)
                }
            }

            setParam("start_page", startPage)
            setParam("end_page", endPage)
            setBookURL(url.toString())
        }
    }, [book, startPage, endPage])

    let renderer: () => ReactNode = useCallback(
        () => {

            if (isFetchingBooks) {
                return <Spinner className='mt-2' />
            }
            return <div className='d-flex book-range-selector'>
                <Select
                    className='mr-2'
                    value={book ? book.id : null}
                    style={{ width: 150 }}
                    placeholder="Select a source"
                    allowClear
                    onChange={(value) => {
                        console.log(value)
                        for (let i = 0; i < books.length; i++) {
                            const book = books[i];
                            if (book.id === value) {
                                setBook(book)
                                return
                            }
                        }
                    }}
                    options={books.map(t => ({ label: t.file.name, value: t.id, ...t }))}
                />
                <div className='d-flex'>
                    <Input
                        type='number'
                        className='mr-2'
                        value={startPage}
                        placeholder='Start Page Number'
                        onChange={(event) => setStartPage(parseInt(event.target.value))}
                    />
                    <Input
                        type='number'
                        className='mr-2'
                        value={endPage}
                        placeholder='End Page Number'
                        onChange={(event) => setEndPage(parseInt(event.target.value))}
                    />
                    <a href={book?.file.url} target='_blank' rel="noreferrer">
                        <Button>
                            View
                            <ExternalLink
                                className='ml-1'
                                fill='#fff'
                                style={{ scale: "0.8" }}
                            />
                        </Button>
                    </a>
                </div>
            </div>
        },
        [book, setBook, books],
    )
    return [bookURL, renderer]
}